import React, { lazy, Suspense } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faBook,
  faFileAlt,
  faSpinner,
  faTimes,
  faUser,
} from '@fortawesome/free-solid-svg-icons'
import { capitalize } from 'lodash'
import { resourceCategories } from '../../../utils/constants'

// Lazy load ReactPlayer
const ReactPlayer = lazy(() => import('react-player'))

const ResourceModal = ({ resource, onClose }) => (
  <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-20">
    <div className="bg-white rounded-lg p-6 w-11/12 h-[90vh] flex flex-col shadow-2xl">
      <div className="flex justify-between items-center mb-4">
        <h2 className="text-md md:text-xl font-bold text-primary">
          {capitalize(resource.title)}
        </h2>
        <button
          onClick={onClose}
          className="text-gray-500 hover:text-gray-700 transition-colors"
        >
          <FontAwesomeIcon icon={faTimes} className="w-6 h-6" />
        </button>
      </div>
      <div className="bg-gray-100 rounded-lg p-4 mb-4 grid grid-cols-1 gap-2 md:grid-cols-3">
        <div className="flex items-center">
          <FontAwesomeIcon icon={faUser} className="text-primary mr-2" />
          <p className="text-sm text-gray-700">
            Subject: <span className="font-semibold">{resource.subject}</span>
          </p>
        </div>
        <div className="flex items-center">
          <FontAwesomeIcon icon={faFileAlt} className="text-primary mr-2" />
          <p className="text-sm text-gray-700">
            Type:{' '}
            <span className="font-semibold">
              {resource.resourceType || resource.type}
            </span>
          </p>
        </div>
        <div className="flex items-center">
          <FontAwesomeIcon icon={faBook} className="text-primary mr-2" />
          <p className="text-sm text-gray-700">
            Level: <span className="font-semibold">{resource.level}</span>
          </p>
        </div>
      </div>

      {/* Cameroonian Educational System Information */}
      {(resource.edSystem ||
        resource.academicLevel ||
        resource.examPreparation ||
        resource.language) && (
        <div className="bg-gray-100 rounded-lg p-4 mb-4 grid grid-cols-1 gap-2 md:grid-cols-2">
          {resource.edSystem && (
            <div className="flex items-center">
              <p className="text-sm text-gray-700">
                Educational System:{' '}
                <span className="font-semibold">{resource.edSystem}</span>
              </p>
            </div>
          )}
          {resource.secondaryType && (
            <div className="flex items-center">
              <p className="text-sm text-gray-700">
                Secondary Level:{' '}
                <span className="font-semibold">{resource.secondaryType}</span>
              </p>
            </div>
          )}
          {resource.academicLevel && (
            <div className="flex items-center">
              <p className="text-sm text-gray-700">
                Academic Level:{' '}
                <span className="font-semibold">{resource.academicLevel}</span>
              </p>
            </div>
          )}
          {resource.examPreparation && (
            <div className="flex items-center">
              <p className="text-sm text-gray-700">
                Exam Preparation:{' '}
                <span className="font-semibold">
                  {resource.examPreparation}
                </span>
              </p>
            </div>
          )}
          {resource.language && (
            <div className="flex items-center">
              <p className="text-sm text-gray-700">
                Language:{' '}
                <span className="font-semibold">{resource.language}</span>
              </p>
            </div>
          )}
        </div>
      )}

      <div className="flex-grow overflow-hidden rounded-lg shadow-inner">
        {resource.resourceType === resourceCategories.YOUTUBE ||
        resource.type === resourceCategories.YOUTUBE ? (
          <Suspense
            fallback={
              <div className="w-full h-full flex items-center justify-center">
                <FontAwesomeIcon icon={faSpinner} spin size="3x" />
              </div>
            }
          >
            <div className="w-full h-full">
              <ReactPlayer
                url={resource.resourceUrl}
                width="100%"
                height="100%"
                controls={true}
                light={true}
                config={{
                  youtube: {
                    playerVars: { modestbranding: 1 },
                  },
                }}
              />
            </div>
          </Suspense>
        ) : (
          <embed
            src={`${resource.resourceUrl}#toolbar=1&navpanes=0&scrollbar=0`}
            type="application/pdf"
            width="100%"
            height="100%"
            className="rounded-lg"
          />
        )}
      </div>
    </div>
  </div>
)

export default ResourceModal
